<template>
  <div id="foot">
    <footer class="footer">
      <div class="footer-nav container abc">
        <dl v-for="item in footData">
          <dt>{{ item.sgL_Title }}</dt>
          <dd v-for="abc in sortList(item.id)">
            <router-link
              v-if="abc.sgL_IsInternal"
              :to="{ path: `/foot/${abc.sgL_IsInternaURL}` }"
            >
              {{ abc.sgL_Title }}
            </router-link>
            <a :href="abc.sgL_IsInternaURL" v-else>
              {{ abc.sgL_Title }}
            </a>
          </dd>
        </dl>
      </div>
      <div class="footer-bottom">
        <div class="copyright">
          <span>
            {{$t('common.Footer.t1')}}
            <a href="mailto:info@soonnet.org">{{$t('common.Footer.t2')}}</a>。
          </span>
          <span
            >Copyright &copy; {{$t('common.Footer.t3')}}</span
          >
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
export default {
  name: "foot",
  data() {
    return {
      base: "",
      allData: [],
      footData: [],
      childData: [],
      pageData: [],
    };
  },
  async created() {
    await this.getContentList();
    this.getFootList();
  },
  methods: {
    async getContentList() {
      const res = await this.$api.permissionApi.GetFootContentList2({
        SkipCount: 0,
        MaxResultCount: 999,
        sgL_IsShow: true,
      });
      this.pageData = res.data.result.items;
    },
    sortList(id) {
      let result = this.allData
        .filter((c) => c.sgL_Parent === id)
        .sort(function (a, b) {
          return a.sgL_Order - b.sgL_Order;
        });
      result
        .filter((c) => c.sgL_IsInternal)
        .forEach((c) => {
          const info = this.pageData.filter(
            (d) => d.id == c.sgL_IsInternaURL
          )[0];
          if (info) {
            c.sgL_IsInternaURL = info.sgL_RequestUrl;
          }
        });
      return result;
    },
    getFootList() {
      this.$api.permissionApi
        .getFootAll({
          SGL_IsShow: true,
          SkipCount: 0,
          MaxResultCount: 999,
        })
        .then((res) => {
          this.allData = res.data.result.items;
          this.footData = this.allData
            .filter((c) => c.sgL_Parent === 0)
            .sort(function (a, b) {
              return a.sgL_Order - b.sgL_Order;
            });
        });
    },
    change(id) {
      // this.selectoption = id;
      this.$store.dispatch("updateCurrentIndex", id);
    },
  },
};
</script>

<style lang="less" scoped>
.abc {
  display: flex;
}
.abc > dl {
  flex: 1;
}
</style>


// WEBPACK FOOTER //
// src/components/common/Footer.vue